import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const SiteListingMaintenace = ({
  getSiteListingMaintenance,
  siteListData,
  getGOLiveFilterDropDown,
  liveFilterDropDown,
}) => {
  const headers = [
    'Site Number',
    'Site Type',
    //'Go Live Date',
    'Site Name',
    'City',
    'Assigned To',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);


  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("mainSiteCont") &&
        localStorage.getItem("mainSiteCont")
    );
    if(installationCont){
      localStorage.setItem("mainGoLive", JSON.stringify(""));
      localStorage.setItem("mainSiteCont", 0);
    }
    
  }, []);

  useEffect(() => {
    if (getSiteListingMaintenance !== null)
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("mainGoLive") &&
            localStorage.getItem("mainGoLive")
        );
        setIsLoading(true);
        if(getcontractFilter){
          await getSiteListingMaintenance(getcontractFilter);
        }else{
         await getSiteListingMaintenance();
        }
        setIsLoading(false);
      })();
  }, [getSiteListingMaintenance]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("mainGoLive", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getSiteListingMaintenance(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    const tableData = [
      'site_id',
      'site_no',
      'site_type',
      //'created_at',
      'client_name',
      'city_name',
      'assigned_to',
    ];
    if (siteListData && siteListData.resultSets) {
      const data = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: [
              {
                name: 'Maintenance Service PR',
                link: `/dashboard/vendor-allocation/2`,
              }
            ],
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getSiteListingMaintenance(filterData,val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.maintenanceSites}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={siteListData?.from}
        onPageChange={onPageChange}
        detailList={siteListData && siteListData.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={
          liveFilterDropDown?.site_type ? liveFilterDropDown : null
        }
        liveFilterDropDown
      />
    </Layout>
  );
};
export default SiteListingMaintenace;
